export enum ServiceMessageIcon {
    IconGift = 'IconGift'
}

export enum ServiceMessageType {
    Negative = 'negative',
    Positive = 'positive',
    Info = 'info'
}

export enum CategoryIcon {
    IconAirport = 'IconAirport',
    IconAssociation = 'IconAssociation',
    IconCampsite = 'IconCampsite',
    IconCarDealership = 'IconCarDealership',
    IconChurch = 'IconChurch',
    IconCinema = 'IconCinema',
    IconCompany = 'IconCompany',
    IconHighway = 'IconHighway',
    IconHospital = 'IconHospital',
    IconHotel = 'IconHotel',
    IconPark = 'IconPark',
    IconParking = 'IconParking',
    IconPerson = 'IconPerson',
    IconPoint = 'IconPoint',
    IconPublicRoads = 'IconPublicRoads',
    IconRestaurant = 'IconRestaurant',
    IconSchool = 'IconSchool',
    IconServiceStation = 'IconServiceStation',
    IconShop = 'IconShop',
    IconStation = 'IconStation',
    IconTownHall = 'IconTownHall',
    IconUnknown = 'IconUnknown'
}

export enum FilterButtonIcon {
    IconComment = 'IconComment',
    IconBolt = 'IconBolt',
    IconSpeaker = 'IconSpeaker'
}
